export const ENV_PRODUCTION = 'production';
export const ENV_STAGING = 'staging';
export const ENV_API_PROD = 'Prod';
export const ENV_API_PREPROD = 'PreProd';

export const ACTION_GET_GLOBAL_SEARCH_AUTOCOMPLETE_DATA = 'get_global_search_autocomplete_data';
export const ACTION_GET_OFFERS = 'get_offers';
export const ACTION_GET_ROOMS = 'get_rooms';
export const ACTION_GET_THINGS_TO_DO = 'get_things_to_do';
export const ACTION_GET_VENUES = 'get_venues';
export const ACTION_GET_BOOKING_API_TOKEN = '';

export const COOKIE_KEY_API_TOKEN = 'indcoll_standalone_ba_token';

export const COOKIE_KEY_HEADER_NOTIFICATIONS_EXPIRY = window.IndCollStandalone['sharedConstants']['COOKIE_KEY_HEADER_NOTIFICATIONS_EXPIRY'];

export const EVENT_BALANCE_ELEMENTS = 'balance_elements.indcoll_standalone';
export const EVENT_BOOKING_FORM_LOADED = 'booking_form_loaded';

export const EVENT_OFFERS_TYPE_FILTER_CHANGED = 'offers_type_filter_changed.indcoll_standalone';
export const EVENT_ROOMS_TYPE_FILTER_CHANGED = 'rooms_type_filter_changed.indcoll_standalone';
export const EVENT_THINGS_TO_DO_TYPE_FILTER_CHANGED = 'things_to_do_type_filter_changed.indcoll_standalone';
export const EVENT_VENUES_TYPE_FILTER_CHANGED = 'venues_type_filter_changed.indcoll_standalone';

export const DATE_FORMAT_IN_VIEW = 'DD MMM, YYYY';
export const DATE_FORMAT_AUS = 'DD/MM/YYYY';
export const DATE_FORMAT_ISO = 'MM/DD/YYYY';
export const DATE_FORMAT_SITEMINDER = 'YYYY-MM-DD';



// WEBPACK FOOTER //
// ./scripts/util/constants.js